import { render, staticRenderFns } from "./ItemEdit.vue?vue&type=template&id=6ca5e838&scoped=true&"
import script from "./ItemEdit.vue?vue&type=script&lang=js&"
export * from "./ItemEdit.vue?vue&type=script&lang=js&"
import style0 from "./ItemEdit.vue?vue&type=style&index=0&id=6ca5e838&prod&lang=scss&"
import style1 from "./ItemEdit.vue?vue&type=style&index=1&id=6ca5e838&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca5e838",
  null
  
)

export default component.exports